import { Nav, Navbar, Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import img from "../img/muhanlogo-removebg-preview.png";
import "./Navigation.css";

export function Navigation() {
  return (
    <Navbar expand="sm" bg="dark" variant="dark">
      <Container>
        <Navbar.Brand href="#home">
          <img
            alt=""
            src={img}
            height="30"
            className="d-inline-block align-top"
          />{" "}
          <span className="title">무한도전 닮은꼴 테스트</span>
        </Navbar.Brand>
        <Nav className="me-auto">
          <Nav.Link href="#home">Home</Nav.Link>
          <Nav.Link href="#helper">Helper</Nav.Link>
          {/* <Nav.Link href="#maker">Maker</Nav.Link> */}
        </Nav>
      </Container>
    </Navbar>
  );
}
export default Navigation;
